import React from "react";
import Images from "../../../images";
import { connect } from "react-redux";
import { useHistory } from "react-router-dom";
import UserActions from "../../../store/user/Actions";
import "../../CommonItems/CommonStyle.css";
import "./MenuHeaderSenior.css";
import menu_home_sr from "../../../images/menu_home_sr.svg";
import menu_classes_sr from "../../../images/menu_classes_sr.svg";
import menu_assignment_sr from "../../../images/menu_assignment_sr.svg";
import menu_profile_sr from "../../../images/menu_profile_sr.svg";
function MenuHeaderSenior(props) {
  const {
    headerItemSelected,
    onHeaderItemSelected,
    setNavigationIndex,
    onProfileClick,
  } = props; //redux from dispatch

  return (
    <div className="header-brand">
      <div className="header-column-1">
        <div className="logo-container">
          <span className="login-brand-knovo">knovo</span>
          <span className="login-brand-backpack">Backpack. Sr</span>
        </div>
      </div>
      <div className="header-column-2">
        <div
          className="header-menu-icons"
          onClick={() => {
            onHeaderItemSelected("home");
          }}
        >
          <span
            className={
              headerItemSelected === "home"
                ? "menu-icon-container menu-icon-container-selected"
                : "menu-icon-container"
            }
          >
            <img
              className={
                headerItemSelected === "home"
                  ? "menu-icon-selected"
                  : "menu-icon-default"
              }
              src={menu_home_sr}
              alt="logo"
            />
          </span>
          <span className="menu-label-text">Home</span>
        </div>
        <div
          className={
            headerItemSelected === "classes"
              ? "header-menu-icons menu-classes menu-classes-selected"
              : "header-menu-icons menu-classes"
          }
          onClick={() => {
            setNavigationIndex(0);
            onHeaderItemSelected("classes");
          }}
        >
          <span
            className={
              headerItemSelected === "classes"
                ? "menu-icon-container menu-icon-container-selected"
                : "menu-icon-container"
            }
          >
            <img
              className={
                headerItemSelected === "classes"
                  ? "menu-icon-selected"
                  : "menu-icon-default"
              }
              src={menu_classes_sr}
              alt="logo"
            />
          </span>
          <span
            className={
              headerItemSelected === "classes"
                ? "menu-label-text menu-label-text-selected"
                : "menu-label-text"
            }
          >
            Classes
          </span>
        </div>
        <div
          className="header-menu-icons"
          onClick={() => {
            if (headerItemSelected !== "assignments") {
              onHeaderItemSelected("assignments");
            }
          }}
        >
          <span
            className={
              headerItemSelected === "assignments"
                ? "menu-icon-container menu-icon-container-selected"
                : "menu-icon-container"
            }
          >
            <img
              className={
                headerItemSelected === "assignments"
                  ? "menu-icon-selected"
                  : "menu-icon-default"
              }
              src={menu_assignment_sr}
              alt="logo"
            />
          </span>
          <span
            className={
              headerItemSelected === "assignments"
                ? "menu-label-text menu-label-text-selected"
                : "menu-label-text"
            }
          >
            Lessons
          </span>
        </div>
      </div>
      <div className="header-column-3">
        <div
          className="header-menu-icons menu-profile"
          onClick={() => {
            onProfileClick();
          }}
        >
          <img
            src={menu_profile_sr}
            alt="logo"
            style={{
              width: "50px",
              height: "50px",
              objectFit: "contain",
            }}
          />
          <span className="menu-label-text">Profile</span>
        </div>
      </div>
    </div>
  );
}
const mapStateToProps = (state) => ({
  headerItemSelected: state.user.headerItemSelected,
});

const mapDispatchToProps = (dispatch) => ({
  onHeaderItemSelected: (headerItemSelected) =>
    dispatch(UserActions.onHeaderItemSelected(headerItemSelected)),
  setNavigationIndex: (navigationIndex) =>
    dispatch(UserActions.setNavigationIndex(navigationIndex)),
});

export default connect(mapStateToProps, mapDispatchToProps)(MenuHeaderSenior);
